import { useLanguage } from '../../contexts/LanguageContext';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export default function LanguageSwitcher({ className = '' }) {
  const { language, setLanguage, supportedLanguages } = useLanguage();

  // Find current language display name
  const currentLang = supportedLanguages.find(l => l.code === language);

  return (
    <div className={`inline-flex items-center ${className}`}>
      <Globe className="w-4 h-4 text-slate-500 mr-2" />
      <Select value={language} onValueChange={setLanguage}>
        <SelectTrigger 
          className="h-auto border-0 bg-transparent shadow-none focus:ring-0 p-0 text-sm font-medium text-slate-700 cursor-pointer min-w-[80px]"
          data-testid="language-switcher"
        >
          <SelectValue placeholder="Language">
            {currentLang?.nativeName || language}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {supportedLanguages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.nativeName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
